import React from 'react'
import '../../styles/Expertise/ExpertiseDPEConseil.css'
import expertiseDPEConseilSection1 from '../../assets/expertise/expertise-dpe-conseil-section1.jpg'
import { Fade } from 'react-awesome-reveal'
import { Accordion, Col, Row } from 'react-bootstrap'
import expertiseDPEConseilSection2 from '../../assets/expertise/expertise-dpe-conseil-section2.jpg'
import AccordionText from '../Utils/AccordionText'
import { BrowserView, MobileView } from 'react-device-detect'
import { Helmet } from 'react-helmet'

function ExpertiseDPEConseil() {

    const section2AccordionData = [
        {
            title: "Interprétation approfondie des résultats du DPE",
            text: "Fournir une analyse des résultats détaillés obtenus lors du DPE, en expliquant les implications de chaque indicateur et la signification de la classification énergétique."
        }, {
            title: "Identification des potentiels d'amélioration",
            text: "Mettre en évidence les points faibles en termes de performance énergétique et identifier les opportunités d’amélioration les plus rentables."
        }, {
            title: "Conseils personnalisés",
            text: "Proposer des recommandations sur mesure pour réduire la consommation d’énergie, améliorer le confort des occupants et diminuer l’impact environnemental du bâtiment."
        },
    ]

    const section3AccordionData1 = [
        {
            title: "Expertise technique",
            text: "Bénéficiez de l’expertise d’une équipe de diagnostiqueurs certifiés, doté d’une connaissance approfondie des réglementations en vigueur et des technologies d’efficacité énergétique."
        }, {
            title: "Approche personnalisée",
            text: "Chaque bâtiment étant unique, nos conseils sont entièrement adaptés à vos besoins spécifiques, à la typologie de votre bien et à vos objectifs financiers et écologiques."
        }, {
            title: "Plan d'action concret",
            text: "Recevez un plan d’action clair et détaillé pour mettre en œuvre les améliorations recommandées, avec une estimation des coûts et des retours sur investissement potentiel."
        }
    ]

    const section3AccordionData2 = [
        {
            title: "Phase 1",
            text: "Réalisation du Diagnostic de Performance Énergétique (DPE) de votre propriété."
        }, {
            title: "Phase 2",
            text: "Proposition de travaux de rénovation énergétique réalistes, judicieusement choisis et adaptés à votre propriété, visant à atteindre au moins la classe énergétique « D »."
        }, {
            title: "Phase 3",
            text: "Nouvelle visite sur les lieux pour intégrer les améliorations réalisées et établir un DPE actualisé."
        }
    ]

    const section4AccordionData = [
        {
            title: "1. Demande d'Évaluation",
            text: "Contactez E5M Diagnostics pour exprimer votre besoin d’un DPE Conseil. Un expert dédié sera attribué à votre projet."
        }, {
            title: "2. Diagnostic et Analyse",
            text: "Notre expert réalise le DPE de votre bâtiment (si ce n’est pas déjà fait) et procède à une analyse approfondie des résultats."
        }, {
            title: "3. Rendez-vous de Conseil",
            text: "Un rendez-vous est organisé pour discuter des résultats, présenter les recommandations et répondre à toutes vos questions."
        }, {
            title: "4. Rapport et Plan d'Action",
            text: "Vous recevez un rapport détaillé incluant un plan d’action personnalisé pour améliorer la performance énergétique de votre bien."
        }
    ]

    return (

        <>
            <Helmet>
                <meta name="title" content="Diagnostic DPE Conseil - E5M Diagnostics" />
                <meta name="description" content="Diagnostic DPE Conseil sur Paris et Île-de-France lors de la vente ou de la mise en location de vos biens immobiliers." />
                <meta property="og:title" content="Diagnostic DPE Conseil - E5M Diagnostics" />
                <meta property="og:description" content="Diagnostic DPE Conseil sur Paris et Île-de-France lors de la vente ou de la mise en location de vos biens immobiliers." />
                <meta property="og:url" content="https://www.e5mdiagnostics.fr/diagnostic-DPE-conseil" />
                <link rel="canonical" href="https://www.e5mdiagnostics.fr/diagnostic-DPE-conseil" />
            </Helmet>

            <BrowserView>
                <div id='expertiseDPEConseil'>
                    <div id='header'>
                        <div id='expertiseDPEConseilHeader' className='headerBackground'>
                            <Fade direction={'down'} duration={500}>
                                <div id='headerFilter'>
                                    <h1 id='headerFilterTitle'>Diagnostic DPE Conseil</h1>
                                </div>
                            </Fade>
                        </div>
                    </div>
                    <Row id='expertiseDPEConseilSection1'>
                        <Col>
                            <Fade direction={'left'} duration={500}>
                                <div id='expertiseDPEConseilSection1Left'>
                                    <div className='sectionTitle'>DPE Conseil avec E5M Diagnostic</div>
                                    <div className='sectionText'>
                                        Le service « DPE Conseil » proposé par E5M Diagnostics va au-delà de la simple réalisation d’un Diagnostic de Performance Énergétique (DPE). Cette prestation de conseil est conçue pour accompagner les propriétaires, les bailleurs et les
                                        gestionnaires de biens immobiliers dans l’optimisation de la performance énergétique de leurs bâtiments. Grâce à une approche personnalisée et à l’expertise de nos diagnostiqueurs certifiés, E5M Diagnostics vous aide à comprendre en profondeur
                                        les résultats de votre DPE et à mettre en œuvre des solutions concrètes pour améliorer l’efficacité énergétique de votre bien.
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                        <Col>
                            <Fade direction={'left'} duration={500} delay={100}>
                                <div id='expertiseDPEConseilSection1Right'>
                                    <img src={expertiseDPEConseilSection1} id='expertiseDPEConseilSection1Image' alt='expertise-dpe-conseil-section1' />
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                    <Row id='expertiseDPEConseilSection2'>
                        <Col sm={6}>
                            <div id='expertiseDPEConseilSection2Left'>
                                <Fade direction={'right'} duration={500}>
                                    <img src={expertiseDPEConseilSection2} className='expertiseDPEConseilSection2Image' alt='expertise-dpe-conseil-section2' />
                                </Fade>
                            </div>
                        </Col>
                        <Col sm={6}>
                            <Fade direction={'right'} duration={500} delay={100}>
                                <div id='expertiseDPEConseilSection2Right'>
                                    <h1 className='sectionTitle'>Objectifs du DPE Conseil</h1>
                                    <div className='sectionAccordion'>
                                        <Accordion>
                                            {section2AccordionData.map((item, index) => {
                                                return (
                                                    <AccordionText
                                                        key={index}
                                                        indexKey={index}
                                                        header={item.title}
                                                        body={item.text}
                                                    />
                                                )
                                            })}
                                        </Accordion>
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                    <Row id='expertiseDPEConseilSection3'>
                        <Col>
                            <Fade direction={'left'} duration={500}>
                                <div id='expertiseDPEConseilSection3Left'>
                                    <h1 className='sectionTitle'>Avantages du DPE Conseil avec E5M Diagnostics</h1>
                                    <div className='sectionAccordionDark'>
                                        <Accordion>
                                            {section3AccordionData1.map((item, index) => {
                                                return (
                                                    <AccordionText
                                                        key={index}
                                                        indexKey={index}
                                                        header={item.title}
                                                        body={item.text}
                                                    />
                                                )
                                            })}
                                        </Accordion>
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                        <Col>
                            <Fade direction={'left'} duration={500}>
                                <div id='expertiseDPEConseilSection3Right'>
                                    <h1 className='sectionTitle'>DPE Conseil avec E5M Diagnostics</h1>
                                    <div className='sectionText'>
                                        Nous proposons la prestation de DPE Conseil, exécutée selon la méthode réglementaire 3CL (calcul de la consommation conventionnelle des logements), spécifiquement pour les propriétés en copropriété. Cette prestation se divise en
                                        trois phases principales :
                                    </div>
                                    <div className='sectionAccordionDark'>
                                        <Accordion>
                                            {section3AccordionData2.map((item, index) => {
                                                return (
                                                    <AccordionText
                                                        key={index}
                                                        indexKey={index}
                                                        header={item.title}
                                                        body={item.text}
                                                    />
                                                )
                                            })}
                                        </Accordion>
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                    <Row id='expertiseDPEConseilSection4'>
                        <Col>
                            <Fade direction={'right'} duration={500}>
                                <div id='expertiseDPEConseilSection4Left'>
                                    <h1 className='sectionTitle'>Dans quel cas est-il recommandé d'opter pour un DPE Conseil ?</h1>
                                    <div className='sectionText'>
                                        <ul>
                                            <li>Avant la vente d’une propriété en copropriété classée « G », « F », ou « E », pour offrir des alternatives de rénovation énergétique à l’acheteur potentiel.</li>
                                            <li>Lors de la demande d’un « éco-PTZ » ; votre institution financière exigera de connaître la nouvelle classe énergétique de votre propriété après réalisation des travaux.</li>
                                            <li>En tant que bailleur, pour satisfaire aux normes réglementaires relatives à la mise en localisation des propriétés classées « G », « F », ou « E ».</li>
                                            <li>Si vous désirez simplement améliorer la performance énergétique de votre habitation.</li>
                                        </ul>
                                    </div>
                                    <div className='sectionText'>
                                        Peu importe le scénario, s’engager dans cette démarche vous permettra de réduire vos coûts énergétiques, d’augmenter votre confort de vie, de minimiser votre impact sur l’environnement et de revaloriser votre bien.
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                        <Col>
                            <Fade direction={'right'} duration={500}>
                                <div id='expertiseDPEConseilSection4Right'>
                                    <h1 className='sectionTitle'>Comment bénéficier du DPE Conseil ?</h1>
                                    <div className='sectionAccordion'>
                                        <Accordion>
                                            {section4AccordionData.map((item, index) => {
                                                return (
                                                    <AccordionText
                                                        key={index}
                                                        indexKey={index}
                                                        header={item.title}
                                                        body={item.text}
                                                    />
                                                )
                                            })}
                                        </Accordion>
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                </div>
            </BrowserView>

            <MobileView>
                <div id='expertiseDPEConseil'>
                    <div id='header'>
                        <div id='expertiseDPEConseilHeader' className='headerBackground'>
                            <Fade direction={'down'} duration={500}>
                                <div id='headerFilterMobile'>
                                    <h1 id='headerFilterTitleMobile'>Diagnostic DPE Conseil</h1>
                                </div>
                            </Fade>
                        </div>
                    </div>
                    <div id='expertiseDPEConseilSection1Mobile' className='sectionDarkMobile'>
                        <Fade direction={'left'} duration={500}>
                            <div className='sectionTitleMobile'>DPE Conseil avec E5M Diagnostic</div>
                            <div className='sectionTextMobile'>
                                Le service « DPE Conseil » proposé par E5M Diagnostics va au-delà de la simple réalisation d'un Diagnostic de Performance Énergétique (DPE). Cette prestation de conseil est conçue pour accompagner les propriétaires, les bailleurs et les
                                gestionnaires de biens immobiliers dans l'optimisation de la performance énergétique de leurs bâtiments. Grâce à une approche personnalisée et à l'expertise de nos diagnostiqueurs certifiés, E5M Diagnostics vous aide à comprendre en profondeur
                                les résultats de votre DPE et à mettre en œuvre des solutions concrètes pour améliorer l'efficacité énergétique de votre bien.
                            </div>
                        </Fade>
                        <Fade direction={'left'} duration={500} delay={100}>
                            <img src={expertiseDPEConseilSection1} id='expertiseDPEConseilSection1ImageMobile' alt='expertise-dpe-conseil-section1' />
                        </Fade>
                    </div>
                    <div id='expertiseDPEConseilSection2Mobile'>
                        <Fade direction={'right'} duration={500}>
                            <img src={expertiseDPEConseilSection2} className='expertiseDPEConseilSection2ImageMobile' alt='expertise-dpe-conseil-section2' />
                        </Fade>
                        <Fade direction={'right'} duration={500} delay={100}>
                            <h1 className='sectionTitleMobile'>Objectifs du DPE Conseil</h1>
                            <div className='sectionAccordionMobile'>
                                <Accordion>
                                    {section2AccordionData.map((item, index) => {
                                        return (
                                            <AccordionText
                                                key={index}
                                                indexKey={index}
                                                header={item.title}
                                                body={item.text}
                                            />
                                        )
                                    })}
                                </Accordion>
                            </div>
                        </Fade>
                    </div>
                    <div id='expertiseDPEConseilSection3Mobile' className='sectionDarkMobile'>
                        <Fade direction={'left'} duration={500}>
                            <h1 className='sectionTitleMobile'>Avantages du DPE Conseil avec E5M Diagnostics</h1>
                            <div className='sectionAccordionDark sectionAccordionDarkMobile'>
                                <Accordion>
                                    {section3AccordionData1.map((item, index) => {
                                        return (
                                            <AccordionText
                                                key={index}
                                                indexKey={index}
                                                header={item.title}
                                                body={item.text}
                                            />
                                        )
                                    })}
                                </Accordion>
                            </div>
                        </Fade>
                        <Fade direction={'left'} duration={500}>
                            <h1 className='sectionTitleMobile'>DPE Conseil avec E5M Diagnostics</h1>
                            <div className='sectionTextMobile'>
                                Nous proposons la prestation de DPE Conseil, exécutée selon la méthode réglementaire 3CL (calcul de la consommation conventionnelle des logements), spécifiquement pour les propriétés en copropriété. Cette prestation se divise en
                                trois phases principales :
                            </div>
                            <div className='sectionAccordionDark sectionAccordionDarkMobile'>
                                <Accordion>
                                    {section3AccordionData2.map((item, index) => {
                                        return (
                                            <AccordionText
                                                key={index}
                                                indexKey={index}
                                                header={item.title}
                                                body={item.text}
                                            />
                                        )
                                    })}
                                </Accordion>
                            </div>
                        </Fade>
                    </div>
                    <div id='expertiseDPEConseilSection4Mobile'>
                        <Fade direction={'right'} duration={500}>
                            <h1 className='sectionTitleMobile'>Dans quel cas est-il recommandé d'opter pour un DPE Conseil ?</h1>
                            <div className='sectionTextMobile'>
                                <ul>
                                    <li>Avant la vente d'une propriété en copropriété classée « G », « F », ou « E », pour offrir des alternatives de rénovation énergétique à l'acheteur potentiel.</li>
                                    <li>Lors de la demande d'un « éco-PTZ » ; votre institution financière exigera de connaître la nouvelle classe énergétique de votre propriété après réalisation des travaux.</li>
                                    <li>En tant que bailleur, pour satisfaire aux normes réglementaires relatives à la mise en localisation des propriétés classées « G », « F », ou « E ».</li>
                                    <li>Si vous désirez simplement améliorer la performance énergétique de votre habitation.</li>
                                </ul>
                            </div>
                            <div className='sectionTextMobile'>
                                Peu importe le scénario, s'engager dans cette démarche vous permettra de réduire vos coûts énergétiques, d'augmenter votre confort de vie, de minimiser votre impact sur l'environnement et de revaloriser votre bien.
                            </div>
                        </Fade>
                        <Fade direction={'right'} duration={500}>
                            <h1 className='sectionTitleMobile'>Comment bénéficier du DPE Conseil ?</h1>
                            <div className='sectionAccordionMobile'>
                                <Accordion>
                                    {section4AccordionData.map((item, index) => {
                                        return (
                                            <AccordionText
                                                key={index}
                                                indexKey={index}
                                                header={item.title}
                                                body={item.text}
                                            />
                                        )
                                    })}
                                </Accordion>
                            </div>
                        </Fade>
                    </div>
                </div>
            </MobileView>
        </>

    )

}

export default ExpertiseDPEConseil